module.exports = __webpack_public_path__ + "img/avatar2.302b630c.png";